import { useDynamicPageStore } from '~/stores/dynamicPage';

export default {
  data() {
    return {
      dynamicPageStore: useDynamicPageStore(),
    };
  },
  computed: {
    isRolePage() {
      if (this.$route.name === 'slug') {
        return this.dynamicPageStore.isRolePage;
      }

      return false;
    },
    isLeadGenPage() {
      if (this.$route.name === 'slug') {
        return this.dynamicPageStore.isLeadGenPage;
      }

      return false;
    },
    pageName() {
      if (this.isRolePage) {
        return 'role-page';
      }
      if (this.isLeadGenPage) {
        return 'lead-gen-page';
      }
      return this.$route.name === 'index' ? 'homepage' : this.$route.name;
    },
  },
};
